import BaseGenericEvent from '../../BaseGenericEvent';
import {RailsPdtConstants} from '../../PdtHelper/RailsPdtConstants';
import { getSearchEventData, getTrainListData, getAvailabilityCardClickedData } from "../../PdtHelper/RailsPdtUtils";
import { RAIL_SEARCH_CONTEXT_DATA_TYPE, RAIL_LISTING_PAGE_DATA_TYPE, RAIL_AVAILABILITY_CARD_DATA_TYPE } from '../../PdtHelper/RailsPdtUtils';

export default class RailsPdtListingEvent extends BaseGenericEvent {

  constructor(pdtData, dataType) {
    const data = pdtData;
    data.pageName = RailsPdtConstants.FunnelStep.LISTING;
    data.funnelStep = RailsPdtConstants.FunnelStep.LISTING;
    super(data);
    this.searchData = pdtData.searchData;
    this.searchContextData = pdtData.searchContextData;
    this.selectedClass = pdtData.selectedClass;
    this.dataType = dataType;
  }

  trackListingEvent = () => {
    const basePdtObject = this.basePdtData();
    switch (this.dataType) {
      case RAIL_SEARCH_CONTEXT_DATA_TYPE:
        basePdtObject.rail_search_context = getSearchEventData(this.searchData);
        break;

      case RAIL_AVAILABILITY_CARD_DATA_TYPE  :
        basePdtObject.train_available_clicked_details = getAvailabilityCardClickedData(this.searchData,this.selectedClass);
        basePdtObject.rail_search_context = getSearchEventData(this.searchContextData);
        break;

      case RAIL_LISTING_PAGE_DATA_TYPE:
        [basePdtObject.train_list,basePdtObject.train_tickets_count] = getTrainListData(this.searchData);
        basePdtObject.rail_search_context = getSearchEventData(this.searchContextData);
        break;

      default:
        break;
    }
    return basePdtObject;
  }
}

